<ng-template #modalTmpl>
  <div
    mat-dialog-content
    class="p-0! w-full h-full flex! justify-center items-center relative p-16px"
  >
    <img
      *ngIf="!document.isFilePdf"
      src="{{ document?.base64 }}"
      alt="img"
      class="rounded-3px"
    />

    <pdf-viewer
      *ngIf="document.isFilePdf"
      [src]="pdfSrc"
      class="rounded-3px"
      [render-text]="true"
      [original-size]="false"
      style="width: 85%; height: 85%"
    ></pdf-viewer>

    <button
      mat-button
      mat-dialog-close
      type="button"
      class="absolute shadow-ff min-w-32px min-h-32px flex justify-center items-center top-24px right-24px rounded-full bg-white"
    >
      <i class="material-icons text-secondary! text-18px">close</i>
    </button>
  </div>
</ng-template>
